import { useDispatch, useSelector } from "react-redux";
import EttersendelserCommon from "../../Detalj/Ettersendelser";

import { getMiljoEttersendelserEttersendelsebrevPdf } from "../../../../actions/miljoEttersendelsebrevActions";

const Ettersendelser = () => {
  const ettersendelser = useSelector((store) =>
    getEttersendelser(store.miljogebyrEttersendelser)
  );

  const dispatch = useDispatch();

  const handleGetIleggelseEttersendelserEttersendelsebrevPdf = (
    miljogebyrEttersendelseBrevId
  ) => {
    dispatch(
      getMiljoEttersendelserEttersendelsebrevPdf(miljogebyrEttersendelseBrevId)
    );
  };
  return (
    <EttersendelserCommon
      nyEttersendelse={true}
      hideIfEmpty={true}
      ettersendelser={ettersendelser}
      getEttersendelserEttersendelsebrevPdf={
        handleGetIleggelseEttersendelserEttersendelsebrevPdf
      }
    />
  );
};

const getEttersendelser = (ettersendelser) => {
  ettersendelser &&
    ettersendelser
      .filter((ettersendelse) => !ettersendelse.betjentId)
      .sort((a, b) => {
        if (a.ettersendelseDato > b.ettersendelseDato) {
          return -1;
        } else if (a.ettersendelseDato < b.ettersendelseDato) {
          return 1;
        } else {
          return 0;
        }
      });
};

export default Ettersendelser;
